module.exports = __webpack_public_path__ + "img/banner_activity.7fbd90bc.png";